import styled from 'styled-components';
import { Label } from '../../../Components/uielements';
import { key, palette } from 'styled-theme';
import { media } from '../../../helper/styleHelper';

export const Layout = styled.div`
  display: grid;
  grid-auto-flow: row;
  min-height: 100vh;
  max-width: 3000px;
  margin: 0 auto;
  flex: 1;
  width: 100%;
`;

export const LayoutV2 = styled.div`
  display: grid;
  grid-auto-flow: row;
  min-height: fit-content;
  max-width: 3000px;
  margin: 0 auto;
  flex: 1;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  flex: auto;
  border-radius: 0px;
  overflow-y: auto;
  position: relative;
  width: 84%;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 40px;
  border: 1px solid ${palette('border', 1)};
  border-radius: ${key('sizes.borderRadius.tiny', '10px')};
  padding: 30px 20px;
  height: fit-content;

  ${media.xxs`
    width: 90%;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px 15px;
  `};

  ${media.xs`
    width: 90%;
    margin-top: 22px;
    margin-bottom: 25px;
    padding: 22px 16px;
  `};

  ${media.sm`
    width: 90%;
    margin-top: 25px;
    margin-bottom: 30px;
    padding: 25px 18px;
  `};

  ${media.md`
    width: 85%;
    margin-top: 28px;
    margin-bottom: 35px;
    padding: 28px 20px;
  `};

  ${media.lg`
    width: 84%;
    margin-top: 30px;
    margin-bottom: 40px;
    padding: 30px 20px;
  `};

  ${media.xl`
    width: 84%;
    margin-top: 30px;
    margin-bottom: 40px;
    padding: 30px 20px;
  `};

  ${media.xxl`
    width: 84%;
    margin-top: 30px;
    margin-bottom: 40px;
    padding: 30px 20px;
  `};
`;

export const LogoContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
`;

export const HeadingTitle = styled(Label)`
  font-family: 'Space Grotesk Regular', Arial, sans-serif;
  font-size: 24px;
  text-align: center;
  color: #fff;

  ${media.xxs`
    font-size: 18px;
  `};

  ${media.xs`
    font-size: 19px;
  `};

  ${media.sm`
    font-size: 21px;
  `};

  ${media.md`
    font-size: 22px;
  `};

  ${media.lg`
    font-size: 24px;
  `};

  ${media.xl`
    font-size: 24px;
  `};

  ${media.xxl`
    font-size: 28px;
  `};

  > span {
    font-size: 0.9em;
  }
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  max-width: fit-content;
  justify-self: center;
  flex-wrap: wrap;
  justify-content: center;

  ${media.xxs`
    gap: 8px;
    margin-top: 16px;
  `};

  ${media.xs`
    gap: 9px;
    margin-top: 17px;
  `};

  ${media.sm`
    gap: 10px;
    margin-top: 18px;
  `};

  ${media.md`
    gap: 10px;
    margin-top: 19px;
  `};

  ${media.lg`
    gap: 10px;
    margin-top: 20px;
  `};
`;

export const Wrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 400px;

  ${media.xxs`
    min-width: 100%;
    padding: 8px 15px 20px;
    gap: 8px;
  `};

  ${media.xs`
    min-width: 100%;
    padding: 9px 16px 22px;
    gap: 9px;
  `};

  ${media.sm`
    min-width: 350px;
    padding: 10px 18px 25px;
    gap: 10px;
  `};

  ${media.md`
    min-width: 380px;
    padding: 10px 20px 28px;
    gap: 10px;
  `};

  ${media.lg`
    min-width: 400px;
    padding: 10px 20px 30px;
    gap: 10px;
  `};
`;

export const Gap = styled.div`
  display: grid;
  gap: 30px;

  ${media.xxs`
    gap: 20px;
  `};

  ${media.xs`
    gap: 22px;
  `};

  ${media.sm`
    gap: 25px;
  `};

  ${media.md`
    gap: 28px;
  `};

  ${media.lg`
    gap: 30px;
  `};
`;

export const MessageTitle = styled.p`
  display: grid;
  justify-content: center;
  align-items: center;
  justify-items: center;
  margin-top: 1%;
  margin-bottom: 0;
  font-size: 18px;
  gap: 20px;
  color: #fff !important;
  text-align: center;

  ${media.xxs`
    font-size: 14px;
    gap: 15px;
    margin-top: 2%;
  `};

  ${media.xs`
    font-size: 15px;
    gap: 16px;
  `};

  ${media.sm`
    font-size: 16px;
    gap: 18px;
  `};

  ${media.md`
    font-size: 17px;
    gap: 19px;
  `};

  ${media.lg`
    font-size: 18px;
    gap: 20px;
  `};

  ${media.xl`
    font-size: 18px;
    gap: 20px;
  `};

  ${media.xxl`
    font-size: 20px;
    gap: 24px;
  `};
`;

export const CenterContent = styled.div`
  width: 60%;
  margin: auto;
  display: grid;
  place-items: center;
  gap: 30px;
  padding: 20px;

  ${media.xxs`
    width: 95%;
    gap: 20px;
    padding: 15px;
  `};

  ${media.xs`
    width: 95%;
    gap: 22px;
    padding: 16px;
  `};

  ${media.sm`
    width: 90%;
    gap: 25px;
    padding: 18px;
  `};

  ${media.md`
    width: 80%;
    gap: 27px;
    padding: 20px;
  `};

  ${media.lg`
    width: 70%;
    gap: 30px;
    padding: 20px;
  `};

  ${media.xl`
    width: 60%;
    gap: 30px;
    padding: 20px;
  `};

  ${media.xxl`
    width: 60%;
    gap: 32px;
    padding: 24px;
  `};
`;

export const ContentContainer = styled.div`
  flex: auto;
  border-radius: 0px;
  overflow-y: auto;
  position: relative;
  width: 84%;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 40px;
  border: 1px solid ${palette('border', 1)};
  border-radius: ${key('sizes.borderRadius.tiny', '10px')};
  padding: 30px 20px;
  height: fit-content;

  ${media.xxs`
    width: 90%;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px 15px;
  `};

  ${media.xs`
    width: 90%;
    margin-top: 22px;
    margin-bottom: 25px;
    padding: 22px 16px;
  `};

  ${media.sm`
    width: 90%;
    margin-top: 25px;
    margin-bottom: 30px;
    padding: 25px 18px;
  `};

  ${media.md`
    width: 85%;
    margin-top: 28px;
    margin-bottom: 35px;
    padding: 28px 20px;
  `};

  ${media.lg`
    width: 84%;
    margin-top: 30px;
    margin-bottom: 40px;
    padding: 30px 20px;
  `};

  ${media.xl`
    width: 84%;
    margin-top: 30px;
    margin-bottom: 40px;
    padding: 30px 20px;
  `};

  ${media.xxl`
    width: 84%;
    margin-top: 30px;
    margin-bottom: 40px;
    padding: 30px 20px;
  `};
`;

export const LinkSpan = styled.span`
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  text-underline-offset: 5px;
  font-weight: 500;

  &:hover {
    color: #63b83a;
    transition: color 0.3s ease;
  }
`;

export const CardContent = styled.div`
  padding: 32px 24px;

  ${media.xxs`
    padding: 20px 15px;
  `};

  ${media.xs`
    padding: 22px 16px;
  `};

  ${media.sm`
    padding: 25px 18px;
  `};

  ${media.md`
    padding: 28px 20px;
  `};

  ${media.lg`
    padding: 32px 24px;
  `};

  ${media.xl`
    padding: 32px 24px;
  `};

  ${media.xxl`
    padding: 36px 28px;
  `};
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 20px;

  ${media.xxs`
    padding: 40px 15px;
    gap: 15px;
  `};

  ${media.xs`
    padding: 45px 16px;
    gap: 16px;
  `};

  ${media.sm`
    padding: 50px 18px;
    gap: 18px;
  `};

  ${media.md`
    padding: 55px 20px;
    gap: 19px;
  `};

  ${media.lg`
    padding: 60px 20px;
    gap: 20px;
  `};

  ${media.xl`
    padding: 60px 20px;
    gap: 20px;
  `};

  ${media.xxl`
    padding: 70px 24px;
    gap: 24px;
  `};
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 20px;
  text-align: center;

  ${media.xxs`
    padding: 30px 15px;
    gap: 15px;
  `};

  ${media.xs`
    padding: 33px 16px;
    gap: 16px;
  `};

  ${media.sm`
    padding: 35px 18px;
    gap: 18px;
  `};

  ${media.md`
    padding: 37px 20px;
    gap: 19px;
  `};

  ${media.lg`
    padding: 40px 20px;
    gap: 20px;
  `};

  ${media.xl`
    padding: 40px 20px;
    gap: 20px;
  `};

  ${media.xxl`
    padding: 45px 24px;
    gap: 24px;
  `};

  svg {
    color: #4caf50;
    width: 60px;
    height: 60px;

    ${media.xxs`
      width: 40px;
      height: 40px;
    `};

    ${media.xs`
      width: 45px;
      height: 45px;
    `};

    ${media.sm`
      width: 50px;
      height: 50px;
    `};

    ${media.lg`
      width: 60px;
      height: 60px;
    `};
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 20px;
  text-align: center;

  ${media.xxs`
    padding: 30px 15px;
    gap: 15px;
  `};

  ${media.xs`
    padding: 33px 16px;
    gap: 16px;
  `};

  ${media.sm`
    padding: 35px 18px;
    gap: 18px;
  `};

  ${media.md`
    padding: 37px 20px;
    gap: 19px;
  `};

  ${media.lg`
    padding: 40px 20px;
    gap: 20px;
  `};

  ${media.xl`
    padding: 40px 20px;
    gap: 20px;
  `};

  ${media.xxl`
    padding: 45px 24px;
    gap: 24px;
  `};

  svg {
    color: #f44336;
    width: 60px;
    height: 60px;

    ${media.xxs`
      width: 40px;
      height: 40px;
    `};

    ${media.xs`
      width: 45px;
      height: 45px;
    `};

    ${media.sm`
      width: 50px;
      height: 50px;
    `};

    ${media.lg`
      width: 60px;
      height: 60px;
    `};
  }
`;

export const InfoText = styled.p`
  font-size: 16px;
  color: #b8b8b8;
  margin: 0;
  font-weight: 500;
  line-height: 1.5;

  ${media.xxs`
    font-size: 13px;
  `};

  ${media.xs`
    font-size: 14px;
  `};

  ${media.sm`
    font-size: 15px;
  `};

  ${media.md`
    font-size: 15px;
  `};

  ${media.lg`
    font-size: 16px;
  `};

  ${media.xl`
    font-size: 16px;
  `};

  ${media.xxl`
    font-size: 17px;
  `};
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #ffebee;
  border: 1px solid #f44336;
  border-radius: 6px;
  color: #c62828;
  font-size: 13px;
  font-weight: 500;
  margin-top: 8px;
  width: 100%;
  box-sizing: border-box;

  ${media.xxs`
    padding: 10px;
    gap: 6px;
    font-size: 11px;
    margin-top: 6px;
  `};

  ${media.xs`
    padding: 10px;
    gap: 7px;
    font-size: 12px;
    margin-top: 7px;
  `};

  ${media.sm`
    padding: 11px;
    gap: 7px;
    font-size: 12px;
    margin-top: 8px;
  `};

  ${media.md`
    padding: 11px;
    gap: 8px;
    font-size: 13px;
    margin-top: 8px;
  `};

  ${media.lg`
    padding: 12px;
    gap: 8px;
    font-size: 13px;
    margin-top: 8px;
  `};

  ${media.xl`
    padding: 12px;
    gap: 8px;
    font-size: 13px;
    margin-top: 8px;
  `};

  ${media.xxl`
    padding: 14px;
    gap: 10px;
    font-size: 14px;
    margin-top: 10px;
  `};
`;
